import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { endpoints } from "@/lib/api";

export default function SchedulePage() {
  const [schedule, setSchedule] = useState([]);
  useEffect(() => { endpoints.schedule().then((r) => setSchedule(r.data)).catch(() => {}); }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto py-10">
      <div className="flex items-center gap-2 mb-2">
        <Clock className="w-7 h-7 text-[#E11D2A]" />
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white">Schedule</h1>
      </div>
      <p className="text-slate-400 mb-8">What's on air today across B&B KIGALI 89.7.</p>
      <div className="space-y-3">
        {schedule.map((s) => (
          <div key={s.id} data-testid={`schedule-row-${s.id}`}
            className={`flex items-center gap-5 rounded-xl border p-5 ${s.status === "on-air" ? "border-[#E11D2A] bg-[#E11D2A]/10" : "border-[#273042] bg-[#121620]"}`}>
            <div className="font-mono text-sm text-slate-300 w-28 shrink-0">{s.time}</div>
            <div className="flex-1">
              <div className="text-white font-semibold">{s.showTitle}</div>
              <div className="text-sm text-slate-400">{s.djName}</div>
            </div>
            {s.status === "on-air" && <span className="text-[10px] uppercase font-bold text-[#E11D2A] flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-[#EF4444] live-dot" /> On air</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
